'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { ChevronRightXs } from '@lichtblick/photon/icons/arrows/chevron-right-xs';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import { type FC, type PropsWithChildren, useCallback, useLayoutEffect, useState } from 'react';
import { HOTLINE_MODAL_TITLE } from '@/components/modals/hotline-modal';
import { i18n } from '@/i18n';
import styles from './hotline-modal.module.scss';

export const HotlineModalWithCTA: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { trackCustomEvent } = useTracker();

  const trackEvent = useCallback(() => {
    trackCustomEvent({
      eventName: 'hotline_teaser_impression',
    });
  }, [trackCustomEvent]);

  useLayoutEffect(() => {
    trackEvent();
  }, [trackEvent]);

  return (
    <>
      <BoxCTA
        as="a"
        data-testid="toast"
        href="tel:+494063601718"
        variant="neutral-outline"
        className={classNames(styles.button, styles['button-mobile'])}
        rightSlot={<ChevronRightXs />}
        size="medium"
      >
        Jetzt anrufen
      </BoxCTA>

      <BoxCTA
        data-testid="toast"
        type="button"
        as="button"
        variant="neutral-outline"
        className={classNames(styles.button, styles['button-desktop'])}
        onClick={() => setIsOpen(true)}
        rightSlot={<ChevronRightXs />}
        size="medium"
      >
        Jetzt anrufen
      </BoxCTA>

      <Modal
        footerContent={
          <TextCTA as="button" onClick={() => setIsOpen(false)}>
            {i18n.modal.close}
          </TextCTA>
        }
        isOpen={isOpen}
        onPointerDownOutside={() => setIsOpen(false)}
        title={HOTLINE_MODAL_TITLE}
      >
        {children}
      </Modal>
    </>
  );
};
